import { useT } from '@powerportalspro/react';
import {
  AggregateDataverseChartDataSource,
  QueryAggregate,
  DateGrouping,
  ChartType,
} from '@powerportalspro/react-charts';
import { DataverseChart, Section, SectionColumn } from '@powerportalspro/react-fluent';
import { useMemo } from 'react';

// A radar chart puts each category on a spoke of its own and draws every series as a ring through
// them, which shows the shape of each series at a glance. The first has a spoke per month and a
// ring per year of won revenue (`groupByDateGrouping` and `seriesDateGrouping`) — this year's and
// last year's — so the two years' busy and quiet months stand out. The second has a spoke per purchase timeframe and a ring per rating
// (`seriesColumn`), counting the open opportunities.

const STRINGS_BASE = 'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Demos.ChartDemos.RadarChartShowcaseMainDemo';

export function RadarChartShowcaseMainSample() {
  const t = useT();

  const wonByMonth = useMemo(
    () =>
      new AggregateDataverseChartDataSource({
        tableName: 'opportunity',
        groupByColumn: 'actualclosedate',
        groupByDateGrouping: DateGrouping.MonthOfYear,
        seriesDateGrouping: DateGrouping.Year,
        aggregateColumn: 'estimatedvalue',
        aggregate: QueryAggregate.Sum,
        // Won, and closed this year or last.
        filterXml:
          "<filter><condition attribute='statecode' operator='eq' value='1' /><filter type='or'><condition attribute='actualclosedate' operator='this-year' /><condition attribute='actualclosedate' operator='last-year' /></filter></filter>",
      }),
    [],
  );

  const openByTimeframeAndRating = useMemo(
    () =>
      new AggregateDataverseChartDataSource({
        tableName: 'opportunity',
        groupByColumn: 'purchasetimeframe',
        seriesColumn: 'opportunityratingcode',
        aggregateColumn: 'opportunityid',
        aggregate: QueryAggregate.Count,
        filterXml: "<filter><condition attribute='statecode' operator='eq' value='0' /></filter>",
      }),
    [],
  );

  return (
    <Section borderVisible={false}>
      <SectionColumn>
        <DataverseChart
          dataSource={wonByMonth}
          type={ChartType.Radar}
          title={t(`${STRINGS_BASE}.won-by-month-title`)}
          height="420px"
        />
      </SectionColumn>
      <SectionColumn>
        <DataverseChart
          dataSource={openByTimeframeAndRating}
          type={ChartType.Radar}
          title={t(`${STRINGS_BASE}.timeframe-rating-title`)}
          height="420px"
        />
      </SectionColumn>
    </Section>
  );
}
